<div class="readiness">
  <header class="head">
    <div class="min-w-0">
      <div class="text-lg font-medium">Suburb pages: what each has, and what's missing</div>
      <div class="meta mt-0" *ngIf="view.meta as m">
        {{ view.total | number }} pages<ng-container *ngIf="m.gateReportedAt"> · search check from the build of {{ m.gateReportedAt | date: 'd MMM, h:mm a' }}</ng-container><ng-container *ngIf="m.arrangersComputedAt"> · arrangers counted {{ m.arrangersComputedAt | date: 'd MMM' }}</ng-container>
      </div>
    </div>
    <div class="flex flex-wrap gap-2">
      <button *ngFor="let t of templateKeys" pButton type="button" class="p-button-outlined p-button-sm" icon="pi pi-th-large" [label]="t.label + ' template'" (click)="editTemplate(t.key)"></button>
      <button pButton type="button" class="p-button-outlined p-button-sm readiness-refresh" icon="pi pi-refresh" label="Refresh" [disabled]="view.loading" (click)="view.reload()"></button>
      <button pButton type="button" class="p-button-sm readiness-csv" icon="pi pi-download" label="Export CSV" [loading]="view.exporting" (click)="view.exportCsv()"
              pTooltip="Every page the filters keep" tooltipPosition="top"></button>
    </div>
  </header>

  <app-readiness-filters [filters]="view.filters" [regionOptions]="catalogue.regionOptions" [subRegionGroups]="catalogue.subRegionGroups" [owners]="view.owners"
                         (changed)="filtersChanged($event)" (reset)="view.resetFilters()"></app-readiness-filters>
  <div *ngIf="view.error" class="err text-sm mt-2">{{ view.error }}</div>

  <p-table [value]="view.rows" [lazy]="true" (onLazyLoad)="onLazyLoad($event)" [paginator]="true" [rows]="view.pageSize" [totalRecords]="view.total" [first]="view.first"
           [loading]="view.loading" sortField="name" [sortOrder]="1" dataKey="recordId" [rowTrackBy]="trackRow" styleClass="p-datatable-sm mt-3" responsiveLayout="scroll"
           currentPageReportTemplate="{first}–{last} of {totalRecords}" [showCurrentPageReport]="true">
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="name" class="sticky-col">Page <p-sortIcon field="name"></p-sortIcon></th>
        <th pSortableColumn="region">Region <p-sortIcon field="region"></p-sortIcon></th>
        <th *ngFor="let c of columns">{{ c.label }}</th>
        <th>Photos</th>
        <th class="num">Own blocks</th>
        <th pSortableColumn="gaps" class="num">Gaps <p-sortIcon field="gaps"></p-sortIcon></th>
        <th pSortableColumn="owner">Owner <p-sortIcon field="owner"></p-sortIcon></th>
        <th pSortableColumn="status">Status <p-sortIcon field="status"></p-sortIcon></th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-r>
      <tr [attr.data-record]="r.recordId">
        <td class="sticky-col">
          <a class="font-medium cursor-pointer" (click)="view.openRow(r)">{{ r.name }}</a>
          <span *ngIf="kindLabel(r)" class="kind">{{ kindLabel(r) }}</span>
          <div class="text-500 text-xs url">{{ r.url }}</div>
        </td>
        <td class="text-sm">{{ catalogue.regionName(r.regionId) }}</td>
        <td *ngFor="let c of columns" [attr.data-gap]="c.gap">
          <app-readiness-cell [cell]="cell(r, c.gap)" [fixable]="fixable(r, c.gap)" (open)="view.openGap(r, c.gap)"></app-readiness-cell>
        </td>
        <td class="text-500 text-sm">not built yet</td>
        <td class="num">{{ r.insertedBlocks }}</td>
        <td class="num">{{ r.missing.length }}</td>
        <td>
          <p-dropdown [options]="view.ownerOptions" optionLabel="label" optionValue="value" [ngModel]="r.owner?.userId ?? null" (ngModelChange)="view.setOwner(r, $event)"
                      [filter]="true" appendTo="body" [baseZIndex]="12000" styleClass="owner-pick" placeholder="Nobody"></p-dropdown>
        </td>
        <td>
          <p-dropdown [options]="statusOptions" optionLabel="label" optionValue="value" [ngModel]="r.status" (ngModelChange)="view.setStatus(r, $event)"
                      appendTo="body" [baseZIndex]="12000" styleClass="status-pick"></p-dropdown>
        </td>
      </tr>
    </ng-template>
    <ng-template pTemplate="emptymessage">
      <tr><td [attr.colspan]="columns.length + 7" class="text-600">No pages match.</td></tr>
    </ng-template>
  </p-table>
</div>
